export var colors= {
  'color-1':  'white',//"rgba(102, 195, 131 , 1)" , blanco
  "color-2": '#F2E8FF',//"rgba(242, 177, 52, 1)" , morado
  "color-3": '#DBF9EA  ',//"rgba(235, 85, 59, 1)" , verde
  "color-4": '#E3F2FF',//"rgba(70, 159, 213, 1)", azul
  "color-5": '#F2F5F8',//"rgba(170, 59, 123, 1)" gris
  'color-6':  '#FFE9EE',//"rgba(102, 195, 131 , 1)" , rojo
  "color-7": '#FFF0E8',//"rgba(242, 177, 52, 1)" , naranja
  "color-8": '#fca2b6',//"rgba(235, 85, 59, 1)" , rosado
  "color-9": '#ffcfcf',//"rgba(70, 159, 213, 1)", negro
}
export var colorsFont= {
  'color-1':  'black',//"rgba(102, 195, 131 , 1)" ,
  "color-2": '#8F58FE',//"rgba(242, 177, 52, 1)" , morado
  "color-3": '#2AA434',//"rgba(235, 85, 59, 1)" , verde
  "color-4": '#0073DD',//"rgba(70, 159, 213, 1)", azul
  "color-5": '#26292E',//"rgba(170, 59, 123, 1)" gris
  'color-6':  '#BF1A41',//"rgba(102, 195, 131 , 1)" ,rojo
  "color-7": '#A74410',//"rgba(242, 177, 52, 1)" , naranja
  "color-8": '#ff3b69',//"rgba(235, 85, 59, 1)" , rosado
  "color-9": '#FF5757',//"rgba(70, 159, 213, 1)", negro
}  
export const weekdays = [
  'Lunes', 
  'Martes', 
  'Miercoles', 
  'Jueves',
  'Viernes',
  'Sabado',
  'Domingo', 
]
export const startTimeCalendar= 0
export const startTimeActivities= 9
export const weekdaysLng = {
  es:[
    'Lunes', 
    'Martes', 
    'Miercoles', 
    'Jueves',
    'Viernes',
    'Sabado',
    'Domingo', 
  ],
  en:[
    'Monday', 
    'Tuesday', 
    'Wednesday', 
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday', 
  ]
}

export var colorsDisp= {
  blanco : 'color-1',
  morado : "color-2",
  verde : "color-3", 
  azul : "color-4",
  gris : "color-5", 
  rojo : "color-6",
  naranja : "color-7", 
  rosado : "color-8", 
  negro : "color-9", 
}
export const typetravel ={
  car:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f697.png",
  train:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f683.png",
  bicycle:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f6b2.png",
  walking:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f6b6-200d-2642-fe0f.png",
  boat:"https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/joypixels/291/motor-boat_1f6e5-fe0f.png",
  /*airplane:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f6eb.png",
  rocket:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f680.png",
  alien:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f6f8.png",
  rollerCoaster:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f3a2.png",
  horse:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f40e.png",
  ant:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f41c.png",
  imagination:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f9e0.png",*/
  custom:"https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/2753.png",
}
export const namesTypetrip ={
  es:{
    car: 'En carro',
    train: 'Transporte publico',
    bicycle: 'En bicicleta',
    walking: 'Caminando',
    boat: 'En bote',
    /*airplane:"En avión",
    rocket:"En cohete",
    alien:"En O.V.N.I",
    rollerCoaster:"En montaña rusa",
    horse:"En un caballo",
    ant:"En una hormiga gigante",
    imagination:"En tus sueños",*/
    custom:"Personalizado",
  },
  en:{
    car: 'By car',
    train: 'Public transport',
    bicycle: 'By bike',
    walking: 'Walking',
    boat: 'By boat',
    /*airplane:"By plane",
    rocket:"By rocket",
    alien:"By U.F.O",
    rollerCoaster:"By roller coaster",
    horse:"By Horse",
    ant:"By giant ant",
    imagination:"in Your Dreams",*/
    custom:"Custom",
  },
}
export const categories={
  es:{
    tips:"Travel tips",
    news:"News",
    curiosities:"Curiosities",
    destination:"Destinations",
    whereStay:"Where to stay"
  },
  en:{
    tips:"Travel tips",
    news:"News",
    vuriosities:"Curiosities",
    destination:"Destinations",
    whereStay:"Where to stay"
  },
}

